import { Grid } from '@livecontrol/core-ui';
import { Event } from '@livecontrol/scheduler/model';
import _ from 'lodash';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Panel, ScrollView } from '../../../../components';
import type { Destination, Maybe } from '../../../../graphql-types';
import type { ScheduledEvent } from '../../graphql';
import { Card } from './card';
import Phase = Event.Phase;

const Separator = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10%;
  font-size: 12px;
  margin: auto;
  color: var(--white60);

  ::before {
    position: absolute;
    width: 45%;
    left: 0;
    content: '';
    border-top: 1px solid var(--white40);
  }

  ::after {
    position: absolute;
    width: 45%;
    right: 0;
    content: '';
    border-top: 1px solid var(--white40);
  }
`;

export const Destinations = ({
  scheduledEvent
}: {
  scheduledEvent: ScheduledEvent;
}): React.ReactElement => {
  const destinations = useMemo(() => {
    let tempDestinations: Maybe<Partial<Destination>>[] = [];

    if(!!scheduledEvent.destinations && scheduledEvent.destinations.length) {
      tempDestinations  = scheduledEvent.destinations.map((destination) => ({
        ...destination,
        status:
        destination.type === 'LiveControl' && (scheduledEvent.status === Phase.Live.toString()) ? 'Streaming' : destination.status
      }));
    }

    return tempDestinations;
  }, [scheduledEvent.destinations, scheduledEvent.status]);

  const activeDestinations = useMemo(
    () => destinations.filter((destination) => destination?.active),
    [destinations]
  );

  const inactiveDestinations = useMemo(
    () => destinations.filter((destination) => !destination?.active),
    [destinations]
  );

  return (
    <Grid
      gridTemplateColumns='1fr' // viewport === Viewport.XL || viewport === Viewport.LG ? '1fr minmax(200px, min-content)' : '1fr'
      className='mt-24px mx-24px'
    >
      <div className='pt-8px pr-lg-24px'>
        <h1 className='text-white font-size-18px'>Destinations</h1>
        <ScrollView className='pr-8px'>
          {activeDestinations.length > 0 ? (
            activeDestinations.map((destination) => (
              <Card key={destination?.streamBroadcastId} destination={destination} />
            ))
          ) : (
            <Panel className='mt-8px p-0'>
              <span className='text-white d-flex align-items-center justify-content-center p-16px'>
                No Active Destinations
              </span>
            </Panel>
          )}
          {inactiveDestinations.length > 0 && (
            <>
              <div className='position-relative my-12px'>
                <Separator>Inactive</Separator>
              </div>
              {inactiveDestinations.map((destination) => (
                <Card key={_.uniqueId(destination?.name)} destination={destination} />
              ))}
            </>
          )}
        </ScrollView>
      </div>
    </Grid>
  );
};
